module.exports = __webpack_public_path__ + "img/email.6019c6a3.svg";